import type { ButtonHTMLAttributes, ReactNode } from "react";

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  children: ReactNode;
  variant?: "default" | "ghost" | "danger";
};

export function IconButton({ label, children, className = "", variant = "default", ...props }: IconButtonProps) {
  return (
    <button className={`icon-button icon-button--${variant} ${className}`} type="button" aria-label={label} title={label} {...props}>
      {children}
    </button>
  );
}
